import styles from "./Step.module.scss";
import PropTypes from "prop-types";

export const Step = ({ value, isActive, step, isComplete, id }) => {
  return (
    <div
      className={`${styles["step"]} ${isActive && styles["step--active"]} ${
        isComplete && styles["step--complete"]
      }`}
    >
      <div className={`${styles["step__box"]}`}>
        <div className={`${styles["step__circle"]}`}>
          {isComplete ? (
            <div className={styles["step__circle--check"]}></div>
          ) : (
            value
          )}
        </div>
      </div>
      <div className={styles["step__title"]} id={`checkout-step-${id}`}>{step}</div>
    </div>
  );
};

Step.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isActive: PropTypes.bool,
  isComplete: PropTypes.bool,
  step: PropTypes.string,
  id: PropTypes.string,
};
